<template>
  <unicom-linha class="linha-embaixo">
    <unicom-coluna sm="2" :class="espacamentoMobile">
      <div align="right">Agência Transfusional</div>
    </unicom-coluna>

    <unicom-coluna sm="1" :class="espacamentoMobile">
      <unicom-switch :value="clickSwitch" @input="toggleSwitch" />
    </unicom-coluna>
  </unicom-linha>
</template>

<script>
import SharedMixin from "./SharedMixin.js";

export default {
  mixins: [SharedMixin],
  data() {
    return {
      payload: {
        tipoServico: "Agência Transfusional"
      }
    };
  },
  methods: {},
  watch: {
    dadosServidor(newVal) {
      if (newVal.servicos.length < 1) return;
      newVal.servicos.forEach(servico => {
        if (servico.tipoServico.tipoServico.includes("Agência Transfusional")) {
          this.clickSwitch = true;
          this.emitPayload({
            ...this.payload,
            clickSwitch: this.clickSwitch
          });
        }
      });
    },
    errorServicos(newVal) {
      if (newVal.servicos.length < 1 && this.clickSwitch) {
        this.mensagemDeErro.prontuarios = "Selecione ao menos 1 prontuário";
      } else {
        this.mensagemDeErro.prontuarios = "";
      }
    }
  }
};
</script>
